import { render, staticRenderFns } from "./PhotoZoomModal.vue?vue&type=template&id=1324b840&scoped=true"
import script from "./PhotoZoomModal.vue?vue&type=script&lang=js"
export * from "./PhotoZoomModal.vue?vue&type=script&lang=js"
import style0 from "./PhotoZoomModal.vue?vue&type=style&index=0&id=1324b840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324b840",
  null
  
)

export default component.exports